import { RootState, setBundlePagesBlankState } from '@/store';
import { api } from '../core';
import { FlagPageNode } from './bundleMarkBlank';
import { refreshBundleSectionsWithCurrentFilters } from './getBundleSections';

type BundleMarkNotBlankResponse = FlagPageNode[];

export interface BundleMarkNotBlankRequest {
  bundleId: string;
  bundlePageIds: string[];
}

const bundleMarkNotBlankApi = api.injectEndpoints({
  endpoints: (builder) => ({
    bundleMarkNotBlank: builder.mutation<BundleMarkNotBlankResponse, BundleMarkNotBlankRequest>({
      query: ({ bundleId, bundlePageIds }: BundleMarkNotBlankRequest) => ({
        url: 'bundle/mark/not-blank',
        method: 'POST',
        body: { bundleId, bundlePageIds },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          // The response carries the new blank state, so /bundle does not need refetching.
          dispatch(
            setBundlePagesBlankState({
              pages: data.map(({ pageId, confirmedBlank }) => ({ pageId, isBlank: confirmedBlank })),
            }),
          );
          // Sections still refetch because the blank filters decide which pages are listed.
          refreshBundleSectionsWithCurrentFilters(dispatch, getState() as RootState);
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in bundleMarkNotBlank in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useBundleMarkNotBlankMutation } = bundleMarkNotBlankApi;
